import {
  AfterContentChecked,
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'wz-icon',
  templateUrl: './tunnelsante-icon.component.html',
  styleUrls: ['./tunnelsante-icon.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TunnelSanteIconComponent
  implements AfterContentInit, AfterContentChecked
{
  @ViewChild('layout', { static: true }) layoutRef!: ElementRef;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterContentInit() {
    this.render();
  }

  ngAfterContentChecked() {
    this.render();
  }

  render() {
    const layoutEl: HTMLElement | any = this.layoutRef.nativeElement;
    const iconText = layoutEl.textContent.trim();
    if (iconText) {
      this.renderer.removeChild(this.elRef.nativeElement, layoutEl);
      this.renderer.addClass(this.elRef.nativeElement, `wz-${iconText}`);
    }
  }
}
